import React from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';
import '../../theme/index.scss';
import MagicLinkComponent from './magiclink-component';
import MagicLinkBrokenComponent from './magiclink-broken.component';

const rootElement = document.getElementById('isp-magiclink-container');

const App = () => {
    return <MagicLinkComponent />;
};

const BrokenFallback = (_: FallbackProps) => <MagicLinkBrokenComponent />;

if (rootElement) {
    const root = createRoot(rootElement);
    const render = (Component: React.ComponentType) => {
        root.render(
            <React.StrictMode>
                <ErrorBoundary
                    FallbackComponent={BrokenFallback}
                    onError={(error, info) => console.error('MagicLink crashed', error, info)}
                    onReset={() => window.location.reload()}>
                    <Component />
                </ErrorBoundary>
            </React.StrictMode>
        );
    };

    render(App);
} else {
    console.error('Root element not found');
}
